import { scene1Pointers } from './scene1.pointers';
import { scene2Pointers } from './scene2.pointers';
import { scene3Pointers } from './scene3.pointers';
import { scene4Pointers } from './scene4.pointers';

import { floorPlanPointers } from './floor-plan.pointers';

export const allPointers = {
    scene1Pointers,
    scene2Pointers,
    scene3Pointers,
    scene4Pointers,

    floorPlanPointers
};
